<form
	nz-form
	[formGroup]="form"
	(ngSubmit)="submit()"
	[class.d-none]="success"
	[nzAutoTips]="explainErrorService.autoTips"
>
	<!-- Email -->
	<nz-form-item class="w-100 mb-3">
		<nz-form-control>
			<input
				nz-input
				type="email"
				placeholder="{{ 'atom-sign-in-input-email' | translate }}"
				formControlName="email"
				autocomplete="off"
			/>
		</nz-form-control>
	</nz-form-item>
	<!-- /Email -->
	<!-- Password -->
	<nz-form-item class="w-100 mb-3">
		<nz-form-control>
			<nz-input-group [nzSuffix]="suffixTemplate">
				<input
					nz-input
					[type]="passwordVisible ? 'text' : 'password'"
					placeholder="{{
						'atom-sign-in-input-password' | translate
					}}"
					formControlName="password"
					autocomplete="off"
				/>
			</nz-input-group>
			<ng-template #suffixTemplate>
				<i
					nz-icon
					[nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
					(click)="passwordVisible = !passwordVisible"
				></i>
			</ng-template>
		</nz-form-control>
	</nz-form-item>
	<!-- /Password -->
	<div
		class="w-100 d-flex flex-column-reverse align-items-center justify-content-between"
	>
		<button
			nz-button
			nzType="default"
			type="button"
			routerLink="/lost-password"
			class="my-2 btn-lost-password"
		>
			{{ 'atom-sign-in-forgot-password' | translate }}
		</button>
		<button
			nz-button
			nzType="primary"
			type="submit"
			[disabled]="form.invalid"
			[nzLoading]="processing"
			class="my-2"
		>
			{{ 'atom-sign-in-login' | translate }}
		</button>
	</div>
</form>
<div *ngIf="success" class="d-flex flex-column w-100 align-items-center py-5">
	<p class="mt-4 text-center">{{ 'sign-in-success' | translate }}</p>
	<i nz-icon nzType="loading" theme="outline"></i>
</div>
